<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    window.onbeforeunload = function(e) {
      var message = 'some word'
      e = e || window.event
      if (e) {
        e.returnValue = message
      }
      return '浏览器关闭！'
    }
    setTimeout(() => {
      const id = this.$store.getters.user.id
      if (!id) return
      this.$store.dispatch('msg/createSocket', id)
      this.$store.dispatch('msg/listenForMessages', this)
      window.addEventListener('beforeunload', this.closeSocket)
    }, 1000)
  },
  //   mounted() {
  //   this.$nextTick(() => {
  //     // 如果有socket连接，就不再连接
  //     // if (!this.$store.getters.socket) {
  //     //   this.$store.dispatch('msg/createSocket', this.$store.getters.user)
  //     //   this.$store.dispatch('msg/listenForMessages')
  //     // }
  //     window.addEventListener('beforeunload', this.closeSocket)
  //   })
  // },
  beforeDestroy() {
    this.closeSocket()
    window.removeEventListener('beforeunload', this.closeSocket)
  },
  methods: {
    closeSocket() {
      this.$store.dispatch('msg/closeSocket')
    }
  }
}
</script>
<style>
  .el-notification__title {
    line-height: 1.5;
  }

</style>
